import { WellboresRegistry } from '@go-widgets/well-logs-widget';

import type { IServicesCollection } from 'src/packages/di';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    wellboresRegistry: WellboresRegistry;
  }
}

export async function addWellboresRegistryService(di: IServicesCollection): Promise<void> {
  const dashboardService = di.requireService('dashboardService');

  di.addSingleton('wellboresRegistry', new WellboresRegistry(dashboardService));
}
